import Accordion from '@/common/components/Accordion'
import ButtonLink from '@/common/components/ButtonLink'
import Spinner from '@/common/components/Spinner'
import { formatCurrency, formatPercentage } from '@/common/utils/formatters'
import { UpdateFeeDetailsModal } from '@/features/establishments/components/contract/UpdateFeeDetailsModal'
import { EstablishmentContractType } from '@/features/establishments/types/establishmentContract.type'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { CircleChevronDownIcon, DollarSignIcon, SquareCheckIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const FeeDetailsSection = ({ contract }: { contract?: EstablishmentContractType }) => {
  const { id } = useParams()

  const [displayFetching, setDisplayFetching] = useState(false)

  const isMutating = useIsMutating()
  const isFetching = useIsFetching({ queryKey: ['establishmentCompany', id] })

  useEffect(() => {
    isMutating && setDisplayFetching(true)
  }, [isMutating])

  useEffect(() => {
    !isFetching && setDisplayFetching(false)
  }, [isFetching])

  return (
    <Accordion
      defaultOpen
      head={
        <div className="flex items-center gap-x-3 text-white-800">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateFeeDetailsModal contract={contract} />
          </div>

          <p>Regras e Tarifas</p>

          {displayFetching && !!isFetching && <Spinner className="fill-white-400 size-4" />}
        </div>
      }
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-4 text-white-800">
          <p className="text-sm">Tarifas padrão:</p>

          {Number(contract?.contract_fees?.length) > 0 ? (
            contract?.contract_fees?.map((fee) => (
              <div key={fee.id} className="flex items-center gap-x-4">
                <div className="flex items-center gap-x-2">
                  <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

                  <div className="flex flex-col gap-y-0.5">
                    <p className="text-[10px] leading-3 font-light text-white-400 italic">Tarifa</p>
                    <ButtonLink
                      linkTo={`/fee-templates/${fee.fee_template.id}`}
                      operationKlassToCheckPermission='Admin::Billing::FeeTemplates::Show'
                      dataTestId="fee_template_clickable_link"
                    >
                      <p className="text-xs">{fee.fee_template.display_name}</p>
                    </ButtonLink>
                  </div>
                </div>

                <div className="flex items-center gap-x-1">
                  <DollarSignIcon strokeWidth={1} className="size-5 text-white-400" />

                  <div className="flex flex-col gap-y-0.5">
                    <p className="text-[10px] leading-3 font-light text-white-400 italic">Valor</p>
                    <p className="text-xs text-white-800">
                      {fee.fee_template.calculate_as === 'percentage'
                        ? formatPercentage(Number(fee.value))
                        : formatCurrency(Number(fee.value))}
                    </p>
                  </div>
                </div>

                {fee.main_fee && (
                  <div className="flex items-center gap-x-1">
                    <SquareCheckIcon strokeWidth={1} className="size-5 text-white-400" />

                    <p className="text-xs text-white-400">Tarifa principal</p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="italic font-light">Não possui</p>
          )}
        </div>
      }
    />
  )
}
